import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/test.environment';
import { Observable } from 'rxjs';
import { CreateEwoComponent, CreateEwoDto } from '../create-ewo/create-ewo.component';

export interface Ewo {
  projectNumber: number;
  ewoNumber: number;
  openDate: string | null;
  closedDate: string | null;
  cost: number;
}

@Injectable({ providedIn: 'root' })
export class EwoService {
  constructor(private http: HttpClient) {}

  getOpenEwos(): Observable<Ewo[]> {
    return this.http.get<Ewo[]>(`${environment.apiBaseUrl}/api/ewos/open`);
  }

  getEwosByProject(projectNumber: number): Observable<Ewo[]> {
    return this.http.get<Ewo[]>(`${environment.apiBaseUrl}/api/ewos/by-project/${projectNumber}`);
  }

  createEwo(ewo: CreateEwoDto): Observable<Ewo> {
      return this.http.post<Ewo>(`${environment.apiBaseUrl}/api/ewos/create`, ewo);
    }
}
